import { __awaiter, __generator } from "tslib";
import Vue from 'vue-ltur';
import VueCustomElement from 'vue-custom-element';
import CustomerBookmark from "Login/CustomerBookmark.vue";
import CustomerNavigator from "Login/CustomerNavigator.vue";
import { vueCustomElementOptions } from "static-components";
import { STATE, StateHelper } from "Helper/StateHelper";
import { LOGIN_FLOW_STATES, LoginFlowManager } from "Login/LoginFlowManager";
import { store } from "ltur-state-engine";
var initializeLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url, entryPoint, referrer;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Vue.use(VueCustomElement);
                return [4 /*yield*/, StateHelper.instance.readyStates(STATE.BOOKMARK_INFORMATION, STATE.TRANSLATOR, STATE.USER_STATE)];
            case 1:
                _a.sent();
                url = new URL(location.href);
                entryPoint = url.searchParams.get("entry");
                referrer = url.searchParams.get("referrer") || "index";
                if (window['singleSignOn'] && store.getState().customerState.user.authorities.includes("ROLE_USER")) {
                    location.href = decodeURIComponent(referrer);
                }
                Vue.customElement('c-customer-bookmark', (new CustomerBookmark().$options), vueCustomElementOptions);
                if (window['loginActive']) {
                    Vue.customElement('c-customer-navigator', (new CustomerNavigator().$options), vueCustomElementOptions);
                    document.addEventListener("openRegistration", function (_) { return LoginFlowManager.instance.setState(LOGIN_FLOW_STATES.REGISTER); });
                    document.addEventListener("openLogin", function (_) { return LoginFlowManager.instance.setState(LOGIN_FLOW_STATES.LOGIN); });
                }
                if (window['singleSignOn']) {
                    if (entryPoint == "register")
                        LoginFlowManager.instance.setState(LOGIN_FLOW_STATES.REGISTER);
                    else
                        LoginFlowManager.instance.setState(LOGIN_FLOW_STATES.LOGIN);
                    if (store.getState().customerState.user.authorities.includes("ROLE_USER"))
                        location.href = decodeURIComponent(referrer);
                    store.subscribe(function () {
                        if (store.getState().customerState.user.authorities.includes("ROLE_USER"))
                            location.href = decodeURIComponent(referrer);
                    });
                }
                return [2 /*return*/];
        }
    });
}); };
export default initializeLogin;
